function useStyles () {
    return {
        container: {
            display: 'flex',
            flexDirection: 'column',
        }
    }
}

export { useStyles }